package com.essntl.features.supplier.data.supabase

import com.essntl.features.area.data.supabase.AreaDto
import com.essntl.features.category.data.supabase.CategoryDto
import com.essntl.features.contact.data.supabase.ContactDto
import com.essntl.features.supplier.domain.model.SupplierModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SupplierDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String?,
    val currency: String? = null,
    val description: String?,
    @SerialName("contact_name")
    val contactName: String? = null,
    @SerialName("area_data")
    val area: AreaDto? = null,
    @SerialName("category_data")
    val category: CategoryDto? = null,
    @SerialName("contact_id_data")
    val contact: ContactDto?,
) {
    fun toModel() =
        SupplierModel(
            id = id,
            createdAt = createdAt,
            currency = currency,
            description = description,
            contactName = contactName,
            area = area?.toModel(),
            category = category?.toModel(),
            contact = contact?.toModel(),
        )

    companion object {
        const val COLUMNS_VALUE = "*, area_data:area(*), " +
            "category_data:category(*), " +
            "contact_id_data:contact_id(${ContactDto.COLUMNS_VALUE})"

        fun getColumns() = Columns.raw(COLUMNS_VALUE)
    }
}